import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
    this.element.querySelectorAll('[data-tab]').forEach(($el) => {
      $el.addEventListener('click', () => this.toggleTabs($el));
    });

    this.toggleTabs(this.selectTabToDisplay());
  }

  selectTabToDisplay() {
    let firstTab = this.element.querySelector('[data-tab]'),
      selectedTab = this.element.querySelector(`[data-tab="${window.location.hash}"]`);

    if (!!selectedTab && selectedTab.dataset.hasOwnProperty('turboFrame'))
      selectedTab.click();

    return selectedTab || firstTab;
  }

  toggleTabs($anchor) {
    let tabsSelector = $anchor.dataset.tab;

    this.element.querySelectorAll('[data-tab]').forEach(($el) => $el.querySelector('.title').classList.remove('text-primary'));
    $anchor.querySelector('.title').classList.add('text-primary');

    this.element.querySelectorAll('.tab').forEach(($el) => {
      $el.classList.toggle('hidden', true);
      $el.classList.remove('block', 'fade');
    })
    let $element = this.element.querySelector(`.tab${tabsSelector}`);
    $element.classList.remove('hidden');
    $element.classList.add('fade');
    $element.classList.add('show');
    window.location.hash = tabsSelector;
    setTimeout(() => $element.classList.add('block'), 200);
  }
}